<template>
<div
  :class= "[(ciudadSelected && ciudadSelected.file != undefined && this.searchResource(this.ciudadSelected.file, 'imagen-fondo'))?'full-width full-height background': '']"
  :style=" {backgroundImage: (ciudadSelected && ciudadSelected.file != undefined && this.searchResource(this.ciudadSelected.file, 'imagen-fondo'))? 'url(' + this.searchResource(this.ciudadSelected.file, 'imagen-fondo').url +')':''}">
  <header-page showCiudadSelector/>
  <div class="container">
    <div class="row">
      <div class="col"></div>
      <div class="text-center col-6">
        <div class="row">
          <h5 class="title">MI AGENDA 2030</h5>
        </div>
        <div class="row q-col-gutter-lg col-12">
          <div
            class="box-container col-6 col-md-4"
            v-for="(item) in indices"
            v-bind:key="item.id"
          >
            <IndicesCiudad :datos="item" :datosEnabled="isInArrayIndicesCiudad(item.id)" />
          </div>
        </div>
        <div class="row">
          <h5 class="title">OBSERVATORIO DE INDICADORES</h5>
        </div>
        <div class="row q-col-gutter-lg col-12">
          <div
            class="box-container col-6 col-md-4"
            v-for="(item) in this.indicesTematicosVisibles"
            v-bind:key="item.id"
          >
            <IndicesTematicos :datos="item" :datosEnabled="isInArrayIndicesTematicosCiudad(item.id)" />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
  </div>
</template>

<script>
import IndicesTematicos from '../components/IndicesTematicos.vue';
import IndicesCiudad from '../components/IndicesCiudad.vue';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  components: {
    IndicesTematicos,
    IndicesCiudad,
    HeaderPage
  },
  mixins: [Resources],

  computed: {
    ...mapGetters({
      indices: types.ALL_INDICES,
      indicesCiudad: types.INDICE_CIUDAD,
      indicesTematicosVisibles: types.ALL_INDICES_TEMATICOS_VISIBLES,
      indicesTematicosCiudad: types.INDICE_TEMATICO_CIUDAD,
      ciudadSelected: 'NGUD/ciudadData'
    })
  },

  created () {
    this.$store.dispatch(types.ACTION_GET_ALL_INDICES);
    this.$store.dispatch(types.ACTION_GET_ALL_INDICES_TEMATICOS);
  },
  data () {
    return {
    };
  },
  methods: {
    isInArrayIndicesCiudad (idItem) {
      return this.indicesCiudad.indexOf(idItem);
    },
    isInArrayIndicesTematicosCiudad (idItem) {
      return this.indicesTematicosCiudad.indexOf(idItem);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-family: DINPro;
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.13px;
  color: #052754;
  text-transform: uppercase;
  margin-bottom: 17px;
}
.container{
  padding: 0px !important;
  padding-bottom: 55px;
  height: 100vh;
}
h5{
  margin-top: 47px;
}
.background {
  background-repeat: no-repeat;
  background-size: auto 70vh;
  background-position-x: center;
  background-position-y: bottom;
  background-size: cover;
  background-color: rgba(255,255,255,0.4);
  background-blend-mode: lighten;
}
</style>
